export const ENTITIES = {};
export const EntitiesAllProps = [];
const configEntity = _ref => {
  let {
    constName,
    name,
    entity,
    importExport,
    fields,
    widgets,
    route
  } = _ref;
  const e = {
    constName,
    name,
    entity,
    importExport,
    fields,
    widgets,
    route
  };
  if (constName) ENTITIES[constName] = e;
  const values = Object.keys(e).map(key => e[key]);
  EntitiesAllProps.push({
    values,
    entity: e
  });
  return e;
};

// ENTITIES
configEntity({
  constName: 'ACCOUNTS',
  name: 'accounts',
  entity: 'companies',
  importExport: 'accounts',
  //To set accounts as default tab && dealing with responses from backend
  fields: 'Empresas',
  //To set accounts as default tab && dealing with responses from backend && to format fields (formatDynamicFields)
  widgets: '2',
  route: '/companies'
});
configEntity({
  constName: 'CONTACTS',
  name: 'contacts',
  entity: 'contacts',
  importExport: 'contacts',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'Contactos',
  //To deal with responses from backend (fields/v1/extra/entities) && to format fields (formatDynamicFields)
  route: '/contacts'
});
configEntity({
  constName: 'OPPORTUNITIES',
  name: 'opportunities',
  entity: 'opportunities',
  importExport: 'opportunities',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'Expedientes',
  //Used to format fields (formatDynamicFields)
  widgets: '1',
  route: '/opportunities'
});
configEntity({
  constName: 'USERS',
  name: 'users',
  entity: 'users',
  importExport: 'users',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'tblUsuarios',
  //Used to format fields (formatDynamicFields),
  route: '/users'
});
configEntity({
  constName: 'ACTIVITIES',
  name: 'activities',
  entity: 'activities',
  importExport: 'Gestiones',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'Gestiones',
  //To deal with responses from backend (fields/v1/extra/entities) && to format fields (formatDynamicFields)
  route: '/activities'
});
configEntity({
  constName: 'QUOTES',
  fields: 'COferta' //Used to format fields (formatDynamicFields)
});
configEntity({
  constName: 'CALENDAR',
  name: 'calendar',
  entity: 'agenda',
  importExport: 'tblAgenda',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'tblAgenda',
  //To deal with responses from backend (fields/v1/extra/entities) && to format fields (formatDynamicFields)
  route: '/agenda'
});
configEntity({
  constName: 'SALESORDERS',
  name: 'salesorders',
  entity: 'salesOrders',
  importExport: 'tblSalesOrders',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'tblSalesOrders',
  //To deal with responses from backend (fields/v1/extra/entities) && to format fields (formatDynamicFields)
  route: '/sales-orders'
});
configEntity({
  constName: 'PRODUCTS',
  name: 'products',
  entity: 'products',
  importExport: 'Productos',
  //To deal with responses from backend (/imports/v1/tables)
  fields: 'Productos',
  //To deal with responses from backend (fields/v1/extra/entities)
  route: '/products'
});

// FIELDS
export const FIELD_TYPE_STANDARD = 'standard';
export const FIELD_TYPE_EXTRA = 'extra';
export const FIELD_TYPE_TAB = 'tab';

// CRUD
export const CRUD_TYPE_ADD = 1;
export const CRUD_TYPE_EDIT = 2;
export const CRUD_TYPE_DUPLICATE = 3;

// IMPERSONATION
export const WEBAPP_URL = 'https://app.forcemanager.net';

// API KEYS
export const TAB_APIKEYS = 'apiv4';
export const TAB_INTEGRATIONS = 'integrations';
export const TAB_SANDBOX = 'sandbox';
export const TAB_FTP = 'ftp';
export const TAB_MAPS = 'maps';
export const API_IDS = {
  qdg67p: 'apiv4',
  v4hhx6: 'apiv4',
  ks13xv: 'integrations',
  loo0c1: 'integrations',
  '2wes7z': 'sandbox',
  miq8kf: 'sandbox'
};

// PROVIDERS
export const AUTH_PROVIDERS = {
  FORCEMANAGER: 0,
  ADFS: 3,
  MICROSOFT: 4,
  GOOGLE: 5
};

// IMPORTS
export const MAX_IMPORT_COLUMNS = 50;
export const MAX_IMPORT_ROWS = 50000;
export const MAX_EXPORT_ROWS = 50000;

// PARAMS
export const MIN_IMPORT_COLUMNS_PARAM = 50;
export const MAX_IMPORT_COLUMNS_PARAM = 200;
export const MIN_IMPORT_ROWS_PARAM = 5000;
export const MAX_IMPORT_ROWS_PARAM = 50000;

// SETUP ROLES
export const ID_SETUP_ROLES = {
  GOD: 1,
  IMPLEMENTATOR: 2,
  PROJECT_MANAGER: 3,
  CUSTOMER_SUCCESS_MANAGER: 4,
  TECHNICAL: 5,
  PARTNER_ADMIN: 6,
  PARTNER: 7,
  ADMIN: 8,
  SECOND_ADMIN: 9,
  ENTERPRISE_ADMIN: 10
};